import React, { useState } from "react";
import {ReactComponent as BurgerIcon} from "../../common/assets/svg/burgerIcon.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../common/rootReducer";
import "./SidebarMenu.scss";
import dropdownimg from "../../common/assets/svg/burgerArrow.svg";

interface MenuSidebarData {
  setshowMenuCategories: any;
  categoryMTypes: any;
  scrollToCategory?: any;
  scrollToSubCategory?: any;
  ref?: any;
}

const SidebarMenu: React.FC<MenuSidebarData> = (props) => {
  const menuCategories: Array<string> = useSelector(
    (state: any) => state.restaurant?.restaurantMenuCategories
  );

  const categoriesstate = props?.categoryMTypes;
  const [openCategories, setOpenCategories] = useState<any>({});

  const subCategoryDisplay = (category: string) => {
    setOpenCategories((prev: any) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };
  const subCategoryMTypes = useSelector(
    (state: any) => state?.restaurant?.subCategoryMTypes
  );

  return (
      <div 
        className="SidebarMenu-container-mobile"
        ref={props?.ref}
      >
        <div className="menu-icon-mobile-new">
          <BurgerIcon 
            onClick={() => props?.setshowMenuCategories(false)}
            className="category-filter-icon"
          />
        </div>
        <div className="MenuCategories-container-mobile-new">
          {menuCategories &&
            menuCategories?.filter((category: any) =>
                Object.keys(props?.categoryMTypes)?.includes(category)
              )
              .map((category: any) => (
                <div className="category-and-subcategory-conatiner-mobile">
                  <div className="category-list-mobile">
                    <span className="category-name-mobile">
                      <span 
                        onClick={() => {
                          props?.setshowMenuCategories(false)
                          props?.scrollToCategory(category)
                        }}
                      >{category}</span>{" "}
                      {props?.categoryMTypes[category]?.subCategories?.length > 0 && (
                        <img
                          src={dropdownimg}
                          alt=""
                          onClick={() => subCategoryDisplay(category)}
                          style={{
                            cursor: "pointer",
                            transform: openCategories[category]
                              ? "rotate(90deg)"
                              : "rotate(0deg)",
                          }}
                        />
                      )}{" "}
                    </span>

                    <span className="category-quantity-mobile">
                      ({props?.categoryMTypes[category]?.quantity})
                    </span>
                  </div>

                  {openCategories[category] && (
                    <div className="subcategory-list-mobile">
                      {props.categoryMTypes[category]?.subCategories?.map(
                        (subcategory: any) => (
                          <div className="subcategory-container-new-mobile">
                            <span 
                              className="subcategory-name-mobile"
                              onClick={() => {
                                props?.setshowMenuCategories(false)
                                props?.scrollToSubCategory(subcategory)
                              }}
                            >
                              {subcategory}{" "}
                            </span>
                            <span className="subcategory-quantity-mobile">
                              (
                              {subCategoryMTypes[subcategory]?.quantity > 0 &&
                                subCategoryMTypes[subcategory]?.quantity}
                              )
                            </span>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              ))}
        </div>
      </div>
  );
};

export default SidebarMenu;
